import { defineComponent as F, computed as a, createElementBlock as B, openBlock as l, Fragment as j, createVNode as o, createElementVNode as T, unref as t, renderSlot as v, createBlock as m, createCommentVNode as d, withCtx as n } from "vue";
import { useWorkspace as W, useActiveEntities as x } from "@scalar/api-client/store";
import { ScalarErrorBoundary as p } from "@scalar/components";
import { getSlugUid as z } from "@scalar/oas-utils/transforms";
import G from "./IntroductionSection.vue.js";
import { useFreezing as H } from "../../hooks/useFreezing.js";
import { useNavState as K } from "../../hooks/useNavState.js";
import { generateClientOptions as M } from "../../v2/blocks/scalar-request-example-block/helpers/generate-client-options.js";
import { DEFAULT_INTRODUCTION_SLUG as R } from "../../features/traverse-schema/helpers/traverse-description.js";
import { getXKeysFromObject as D } from "../../features/specification-extension/helpers.js";
import X from "../SectionFlare/SectionFlare.vue.js";
import q from "../../v2/blocks/scalar-info-block/components/InfoBlock.vue.js";
import g from "../../v2/blocks/scalar-info-block/components/IntroductionCardItem.vue.js";
import J from "../../v2/blocks/scalar-server-selector-block/components/ServerSelector.vue.js";
import P from "../../v2/blocks/scalar-auth-selector-block/components/AuthSelector.vue.js";
import Q from "../../v2/blocks/scalar-client-selector-block/components/ClientSelector.vue.js";
import Y from "./Operations/TraversedEntryContainer.vue.js";
import Z from "./Models/Models.vue.js";
const _ = { class: "narrow-references-container" }, he = /* @__PURE__ */ F({
  __name: "Content",
  props: {
    document: {},
    config: {},
    store: {}
  },
  setup(c) {
    H();
    const f = a(
      () => M(c.config.hiddenClients)
    ), { getHeadingId: C } = K(), E = a(
      () => C({
        slug: R,
        depth: 1,
        value: "Introduction"
      })
    ), O = a(
      () => D(c.store.workspace.activeDocument)
    ), U = a(
      () => {
        var e;
        return D((e = c.store.workspace.activeDocument) == null ? void 0 : e.info);
      }
    ), { collections: A, securitySchemes: I, servers: S } = W(), {
      activeCollection: L,
      activeEnvVariables: V,
      activeEnvironment: $,
      activeWorkspace: k
    } = x(), s = a(() => {
      if (c.config.slug) {
        const e = A[z(c.config.slug)];
        if (e)
          return e;
      }
      return L.value;
    }), b = a(() => {
      if (s.value) {
        if (s.value.selectedServerUid) {
          const e = S[s.value.selectedServerUid];
          if (e)
            return e;
        }
        return S[s.value.servers[0]];
      }
    }), N = () => c.store.exportActiveDocument("json") ?? "{}";
    return (e, ee) => {
      var h;
      return l(), B(j, null, [
        o(t(X)),
        T("div", _, [
          v(e.$slots, "start"),
          o(G, {
            showEmptyState: !e.store.workspace.activeDocument
          }, {
            "empty-state": n(() => [
              v(e.$slots, "empty-state")
            ]),
            default: n(() => {
              var y;
              return [
                e.store.workspace.activeDocument ? (l(), m(t(q), {
                  key: 0,
                  id: E.value,
                  documentExtensions: O.value,
                  externalDocs: e.store.workspace.activeDocument.externalDocs,
                  getOriginalDocument: N,
                  info: e.store.workspace.activeDocument.info,
                  infoExtensions: U.value,
                  isLoading: e.config.isLoading,
                  layout: e.config.layout,
                  oasVersion: (y = e.store.workspace.activeDocument) == null ? void 0 : y["x-original-oas-version"],
                  onLoaded: e.config.onLoaded
                }, {
                  selectors: n(() => [
                    o(t(p), null, {
                      default: n(() => {
                        var r, i;
                        return [
                          (i = (r = e.store.workspace.activeDocument) == null ? void 0 : r.servers) != null && i.length ? (l(), m(t(g), {
                            key: 0,
                            class: "scalar-reference-intro-server scalar-client introduction-card-item text-base leading-normal [--scalar-address-bar-height:0px]"
                          }, {
                            default: n(() => {
                              var u, w;
                              return [
                                o(t(J), {
                                  servers: ((u = e.store.workspace.activeDocument) == null ? void 0 : u.servers) ?? [],
                                  xSelectedServer: (w = e.store.workspace.activeDocument) == null ? void 0 : w["x-scalar-active-server"]
                                }, null, 8, ["servers", "xSelectedServer"])
                              ];
                            }),
                            _: 1
                          })) : d("", !0)
                        ];
                      }),
                      _: 1
                    }),
                    o(t(p), null, {
                      default: n(() => [
                        s.value && t(k) && Object.keys(t(I) ?? {}).length ? (l(), m(t(g), {
                          key: 0,
                          class: "scalar-reference-intro-auth scalar-client introduction-card-item leading-normal"
                        }, {
                          default: n(() => {
                            var r, i;
                            return [
                              o(t(P), {
                                collection: s.value,
                                envVariables: t(V),
                                environment: t($),
                                layout: "reference",
                                persistAuth: (r = e.config) == null ? void 0 : r.persistAuth,
                                selectedSecuritySchemeUids: ((i = s.value) == null ? void 0 : i.selectedSecuritySchemeUids) ?? [],
                                server: b.value,
                                title: "Authentication",
                                workspace: t(k)
                              }, null, 8, ["collection", "envVariables", "environment", "persistAuth", "selectedSecuritySchemeUids", "server", "workspace"])
                            ];
                          }),
                          _: 1
                        })) : d("", !0)
                      ]),
                      _: 1
                    }),
                    o(t(p), null, {
                      default: n(() => {
                        var r;
                        return [
                          ((r = e.config) == null ? void 0 : r.hiddenClients) !== !0 && f.value.length ? (l(), m(t(g), {
                            key: 0,
                            class: "introduction-card-item scalar-reference-intro-clients"
                          }, {
                            default: n(() => {
                              var i, u;
                              return [
                                o(t(Q), {
                                  class: "introduction-card-item scalar-reference-intro-clients",
                                  clientOptions: f.value,
                                  xScalarSdkInstallation: (u = (i = e.store.workspace.activeDocument) == null ? void 0 : i.info) == null ? void 0 : u["x-scalar-sdk-installation"],
                                  xSelectedClient: e.store.workspace["x-scalar-default-client"]
                                }, null, 8, ["clientOptions", "xScalarSdkInstallation", "xSelectedClient"])
                              ];
                            }),
                            _: 1
                          })) : d("", !0)
                        ];
                      }),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["id", "documentExtensions", "externalDocs", "info", "infoExtensions", "isLoading", "layout", "oasVersion", "onLoaded"])) : d("", !0)
              ];
            }),
            _: 3
          }, 8, ["showEmptyState"]),
          o(t(Y), {
            clientOptions: f.value,
            config: e.config,
            document: e.document,
            store: e.store
          }, null, 8, ["clientOptions", "config", "document", "store"]),
          (h = e.config) != null && h.hideModels ? d("", !0) : (l(), m(t(Z), {
            key: 0,
            config: e.config,
            document: e.document
          }, null, 8, ["config", "document"])),
          v(e.$slots, "end")
        ])
      ], 64);
    };
  }
});
export {
  he as default
};
